import config from '@core/config/config.json';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth/web-extension';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
const dev = environment !== 'production';

const firebaseConfig = {
  apiKey: config.firebase.apiKey,
  authDomain: config.firebase.authDomain,
  projectId: config.firebase.projectId,
  storageBucket: config.firebase.storageBucket,
  messagingSenderId: config.firebase.messagingSenderId,
  appId: config.firebase.appId,
  measurementId: config.firebase.measurementId,
};

const init = () => {
  const app = initializeApp(firebaseConfig);
  initializeFirestore(app, {});
  return app;
};

const app = getApps().length ? getApp() : init();
let firestore = dev ? getFirestore(app, 'scribeberry-dev') : getFirestore(app);

let auth = getAuth(app);
const storage = getStorage(app);

export { app, firestore, auth, storage };
